import React, { ReactNode, useEffect, useState } from 'react'

import { AccordionGroupContext } from './AccordionGroupContext'

export interface AccordionGroupProps {
  children: ReactNode
  defaultExpanded?: string | false
  expanded?: string | false
  onChange?: (panel: string | false) => void
}

export const AccordionGroup: React.FC<AccordionGroupProps> = (props) => {
  const { children, defaultExpanded = false, onChange } = props
  const [expandedPanel, setExpandedPanel] = useState<string | false>(props.expanded ?? defaultExpanded)

  const isControlled = 'expanded' in props

  useEffect(() => {
    if (isControlled) {
      setExpandedPanel(props.expanded ?? false)
    }
  }, [props.expanded, isControlled])

  useEffect(() => {
    if (isControlled && 'defaultExpanded' in props) {
      console.error(
        'Warning: AccordionGroup elements must be either controlled or uncontrolled (specify either the expanded prop, or the defaultExpanded prop, but not both).'
      )
    }
  }, [props, isControlled])

  const handleAccordionChange = (panel: string) => (isExpanded: boolean) => {
    const newExpandedPanel = isExpanded ? panel : false

    if (!isControlled) {
      setExpandedPanel(newExpandedPanel)
    }

    onChange?.(newExpandedPanel)
  }

  return (
    <AccordionGroupContext.Provider
      value={{
        expandedPanel,
        onPanelChange: handleAccordionChange,
      }}
    >
      {children}
    </AccordionGroupContext.Provider>
  )
}

AccordionGroup.displayName = 'AccordionGroup'
